interface ProfileChallengeCardProps {
  icon: string;
  name: string;
  daysRemaining: number | string;
  progress: number; // 0-100
  onClick?: () => void;
}

export function ProfileChallengeCard({
  icon,
  name,
  daysRemaining,
  progress,
  onClick,
}: ProfileChallengeCardProps) {
  // Format days remaining text
  const daysText =
    typeof daysRemaining === "number"
      ? `${daysRemaining} ${daysRemaining === 1 ? "day" : "days"} remaining`
      : daysRemaining;

  return (
    <div
      className="flex items-center gap-4 rounded-3xl border border-gray-200 dark:border-white/10 bg-card-light dark:bg-black/20 p-4 cursor-pointer hover:bg-gray-50 dark:hover:bg-black/30 transition-colors"
      onClick={onClick}
    >
      <div className="flex h-14 w-14 items-center justify-center rounded-lg bg-primary/20 shrink-0">
        <span className="material-symbols-outlined text-3xl text-primary">
          {icon}
        </span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-gray-900 dark:text-white font-bold truncate">
          {name}
        </p>
        <p className="text-gray-500 dark:text-gray-400 text-sm mb-2">
          {daysText}
        </p>
        <div className="w-full bg-gray-200 dark:bg-white/10 rounded-full h-1.5">
          <div
            className="bg-primary h-1.5 rounded-full transition-all duration-300"
            style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
          />
        </div>
      </div>
    </div>
  );
}
